"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchResults = exports.getPendingContactsLoaded = exports.getPendingContacts = exports.getNbContacts = exports.getCurrentPage = exports.getContactsQuery = exports.getContactStatus = exports.getContactIsInitiator = exports.getAcceptedContactsLoaded = exports.getAcceptedContacts = exports._pendingContactsSelector = void 0;
var _reselect = require("reselect");
var _filter = _interopRequireDefault(require("lodash/filter"));
var _constants = require("./constants");
var _selectors = require("../entities/selectors");
var _selectors2 = require("../session/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var contactsSelector = state => state.contacts;
var contactsEntitySelector = state => (0, _selectors.entitiesSelector)(state).contacts;
var contactsEntitiesAcceptedSelector = state => (0, _filter.default)(contactsEntitySelector(state), value => value.contactStatus === _constants.CONTACT_STATUS.ACCEPTED);
var _pendingContactsSelector = state => contactsSelector(state).pending || [];
exports._pendingContactsSelector = _pendingContactsSelector;
var getAcceptedContactsLoaded = state => contactsSelector(state).acceptedContactsLoaded;
exports.getAcceptedContactsLoaded = getAcceptedContactsLoaded;
var getAcceptedContacts = exports.getAcceptedContacts = (0, _reselect.createSelector)([contactsEntitiesAcceptedSelector, getAcceptedContactsLoaded, _selectors2.getUserId], (contactsAccepted, loaded, _me) => {
  if (!loaded) return [];
  return contactsAccepted.reduce((acc, el) => {
    if (el.id !== _me) acc.push(_objectSpread(_objectSpread({}, el), {}, {
      _user: el.id
    }));
    return acc;
  }, []);
});
var getContactIsInitiator = (state, _user) => {
  var _contactsEntitySelect, _contactsEntitySelect2;
  return (_contactsEntitySelect = (_contactsEntitySelect2 = contactsEntitySelector(state)) === null || _contactsEntitySelect2 === void 0 || (_contactsEntitySelect2 = _contactsEntitySelect2[_user]) === null || _contactsEntitySelect2 === void 0 ? void 0 : _contactsEntitySelect2.isInitiator) !== null && _contactsEntitySelect !== void 0 ? _contactsEntitySelect : false;
};
exports.getContactIsInitiator = getContactIsInitiator;
var getContactStatus = (state, _user) => {
  var _contactsEntitySelect3, _contactsEntitySelect4;
  return (_contactsEntitySelect3 = (_contactsEntitySelect4 = contactsEntitySelector(state)) === null || _contactsEntitySelect4 === void 0 || (_contactsEntitySelect4 = _contactsEntitySelect4[_user]) === null || _contactsEntitySelect4 === void 0 ? void 0 : _contactsEntitySelect4.contactStatus) !== null && _contactsEntitySelect3 !== void 0 ? _contactsEntitySelect3 : -1;
};
exports.getContactStatus = getContactStatus;
var getContactsQuery = state => contactsSelector(state).query;
exports.getContactsQuery = getContactsQuery;
var getCurrentPage = state => contactsSelector(state).currentPage;
exports.getCurrentPage = getCurrentPage;
var getNbContacts = state => contactsSelector(state).nbContacts;
exports.getNbContacts = getNbContacts;
var getPendingContactsLoaded = state => contactsSelector(state).pendingContactsLoaded;
exports.getPendingContactsLoaded = getPendingContactsLoaded;
var getPendingContacts = exports.getPendingContacts = (0, _reselect.createSelector)([contactsEntitySelector, getPendingContactsLoaded, _pendingContactsSelector], (contactsEntity, loaded, _pendingContacts) => {
  if (!loaded || !_pendingContacts || !contactsEntity) return [];
  return _pendingContacts.reduce((result, _contact) => {
    if (contactsEntity[_contact]) result.push(contactsEntity[_contact]);
    return result;
  }, []);
});
var _searchResultsSelector = state => contactsSelector(state)._searchResults;
var getSearchResults = exports.getSearchResults = (0, _reselect.createSelector)([contactsEntitySelector, _searchResultsSelector], (contactsEntity, _searchResults) => {
  if (!_searchResults) return null;
  if (_searchResults.length === 0) return [];
  return _searchResults.reduce((result, _contact) => {
    if (contactsEntity[_contact]) {
      result.push(_objectSpread(_objectSpread({}, contactsEntity[_contact]), {}, {
        _user: contactsEntity[_contact].id
      }));
    }
    return result;
  }, []);
});